"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ArrowButtonDown = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/52-Arrows-Diagrams/01-Arrows/ArrowButtonDown"));
var _spinner = _interopRequireDefault(require("@berlitz/spinner"));
var _Select = require("./Select.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Select = function Select(_ref) {
  var disabled = _ref.disabled,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    id = _ref.id,
    options = _ref.options,
    ghost = _ref.ghost,
    defaultValue = _ref.defaultValue,
    className = _ref.className,
    required = _ref.required,
    placeholder = _ref.placeholder,
    hideLabel = _ref.hideLabel,
    value = _ref.value,
    loading = _ref.loading,
    light = _ref.light;
  var componentProps = {
    id: id,
    disabled: disabled || options.length === 0,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    ghost: ghost,
    defaultValue: defaultValue,
    required: required,
    value: value,
    light: light
  };
  return /*#__PURE__*/_react.default.createElement(_Select.Wrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Select.SelectStyled, _extends({}, componentProps, {
    "data-key": "max-select",
    "aria-label": name
  }), placeholder && /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, placeholder, hideLabel && required && ' *'), options.length && options.map(function (option, index) {
    return /*#__PURE__*/_react.default.createElement("option", {
      selected: option.value === value,
      value: option.value,
      key: "".concat(option.value, "-").concat(index),
      "data-key": "max-select__option",
      disabled: option.disabled
    }, option.label);
  })), loading && /*#__PURE__*/_react.default.createElement(_Select.SpinnerContainer, null, /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "sm"
  })), /*#__PURE__*/_react.default.createElement(_Select.ArrowIconContainer, null, /*#__PURE__*/_react.default.createElement(_ArrowButtonDown.default, {
    size: "xxs",
    color: "brand02"
  })));
};
Select.defaultProps = {
  disabled: false,
  options: []
};
var _default = Select;
exports.default = _default;